import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { ICreateVehicleType, IUpdateVehicleType } from './interfaces/type-vechicle.interface';
import { CompanyService } from '../../configuration/company/company.service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { getCode } from 'app/utils/method';
import { VehicleTypeService } from './type-vehicle.service';
import VehicleTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/transport/vehicle-type/vehicle-type.entity';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { VehicleTypeExport } from './exports/type-vehicle.export';
import { VEHICLE_TYPE_TITLE } from './exports/type-vehicle.constants';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { FilterSectionComponent } from 'app/common/components/filter-section/filter-section.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-type-vehicle',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    StatusFiltersComponent,
    FilterComponent,
    FilterSectionComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    VehicleTypeExport
  ],
  templateUrl: './type-vehicle.component.html',
  styleUrl: './type-vehicle.component.scss'
})
export class TypeVehicleComponent implements OnDestroy {
  getCode = getCode
  displayedColumns: string[] = [
    "name",
    "capacity",
    "company", 
    "statusId", 
    "action"
  ];

  dataSource = new MatTableDataSource<VehicleTypeAttributes>([]);
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof VehicleTypeAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []

  currentVechicleType: ICreateVehicleType = this.initializeCreateVehicleType();
  public id: any = null

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;

  // Status Filter Properties
  selectedStatuses: number[] = [1, 0]; // Default to show both active and inactive

  // Company Filter Properties
  form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;

  constructor(
    private vehicleTypeService: VehicleTypeService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public exportService: ExportService,
    private fb: FormBuilder,
    private vehicleTypeExport: VehicleTypeExport,
  ) {
    // Initialize form for filters
    this.form = this.fb.group({
      companyId: [null]
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  getList(): void {
    let options = { 
      currentPage: this.pageIndex, 
      limitPerPage: this.pageSize, 
      search: this.search, 
      sort: this.sortActive, 
      sortDirection: this.sortDirection,
      // Add filter parameters
      status: this.selectedStatuses.length ? this.selectedStatuses : null,
      companyId: this.form.get('companyId')?.value || null
    }

    this.vehicleTypeService.getAllPaginateVehicleType(options as any).subscribe({
      next: (res: IPaginationResult<VehicleTypeAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener tipos de pago","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateVehicleType(): ICreateVehicleType {
    return { 
      code: "", 
      externalKey: null,
      name: "", 
      capacity: null,
      companyId: null,
    };
  }

  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      }
    });
  }

  openModal(vehicleType?: VehicleTypeAttributes): void {
    this.getAllCompanies()
    if(vehicleType){
      this.currentVechicleType = {
        ...vehicleType,
        externalKey: this.getCode(vehicleType) ? this.getCode(vehicleType): null,
        companyId: vehicleType.company ? vehicleType.company._id.toString() : ""
      };
      this.id = vehicleType._id
    }else{
      this.currentVechicleType = this.initializeCreateVehicleType();
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '90%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  onSubmit(){
    if(this.id == null){
      this.createVehicleType()
    }else{
      this.updateVehicleType(this.id)
    }
  }

  createVehicleType(): void {
    const createVehicleType: ICreateVehicleType = { 
      ...this.currentVechicleType, 
      //externalKey: this.currentVechicleType.externalKey.code == null ? null : this.currentVechicleType.externalKeys.code
    };

    this.vehicleTypeService.create(createVehicleType).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRef){
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateVehicleType(id: string): void {
   if (this.currentVechicleType) {
      const updatedVehicleType: IUpdateVehicleType = { ...this.currentVechicleType };

      this.vehicleTypeService.update(id, updatedVehicleType).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if(this.dialogRef){
            this.dialogRef.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, vehicleType: VehicleTypeAttributes): void {
    const originalStatusId = vehicleType.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedVehicleType = { ...vehicleType, statusId: updatedStatusId };

    this.vehicleTypeService.update(vehicleType._id.toString(), updatedVehicleType).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        vehicleType.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(vehicleType: VehicleTypeAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: vehicleType, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(vehicleType._id.toString()));
  }

  delete(id: string): void {
    this.vehicleTypeService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  onExportButtonPressed() {
    if (!this.vehicleTypeExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: VEHICLE_TYPE_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.vehicleTypeExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  // Status Filter Methods
  applyStatusFilter(): void {
    this.pageIndex = 1; // Reset to first page when filtering
    this.getList();
  }

  // Company Filter Methods
  onFilterEvent(event: any): void {
    this.pageIndex = 1; // Reset to first page when filtering
    this.getList();
  }

  onCleanEvent(event: any): void {
    this.form.patchValue({
      companyId: null
    });
    this.pageIndex = 1;
    this.getList();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
